module.exports = __webpack_public_path__ + "img/11.7b38bbde.png";